module.exports = __webpack_public_path__ + "static/img/summer_banner.0e039c10.jpg";